"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var Styled = __importStar(require("./StatusStyles"));
var body_1 = __importDefault(require("../body"));
var Status = function (_a) {
    var className = _a.className, _b = _a.status, status = _b === void 0 ? "neutral" : _b, hideText = _a.hideText, withoutMargins = _a.withoutMargins, children = _a.children, statusMapper = _a.statusMapper, _c = _a.tooltip, tooltip = _c === void 0 ? false : _c, textTransform = _a.textTransform, loading = _a.loading, _d = _a.variant, variant = _d === void 0 ? "default" : _d, props = __rest(_a, ["className", "status", "hideText", "withoutMargins", "children", "statusMapper", "tooltip", "textTransform", "loading", "variant"]);
    if (variant === "rectangular") {
        return (React.createElement(Styled.StatusFieldWrapper, null,
            React.createElement(Styled.StatusField, { loading: loading, status: status, statusMapper: statusMapper }, !hideText && children ? (loading ? (React.createElement(Styled.StatusLoadingSkeleton, null)) : (React.createElement(body_1.default, { size: "xs", withoutMargins: true }, children))) : (!hideText &&
                (loading ? (React.createElement(Styled.StatusLoadingSkeleton, null)) : (React.createElement(body_1.default, { size: "xs", withoutMargins: true }, status)))))));
    }
    else {
        return (React.createElement(Styled.StatusCircleContainer, __assign({ withoutMargins: withoutMargins }, props),
            React.createElement(Styled.StatusCircle, { tooltip: true, status: status, statusMapper: statusMapper, loading: loading }),
            tooltip && (React.createElement(Styled.TooltipBox, null,
                React.createElement("p", { style: { margin: 0 } }, status.toUpperCase()))),
            !hideText && children ? (loading ? (React.createElement(Styled.StatusLoadingSkeleton, null)) : (React.createElement(Styled.StatusCircleText, null, typeof children === "string" ? children.toUpperCase() : children))) : (!hideText &&
                (loading ? (React.createElement(Styled.StatusLoadingSkeleton, null)) : (React.createElement(Styled.StatusCircleText, { textTransform: textTransform }, status))))));
    }
};
exports.default = Status;
